import { combineReducers } from '@reduxjs/toolkit';

/**
 * Reducers within Provider Search Reducer
 */

import { searchReducer, SearchState } from './search/reducers';
import {
  providerSuggestionsReducer,
  ProviderSuggestionsState
} from './providerSuggestions/reducers';
import { facetsReducer, FacetsState } from './facets/reducers';

import { insurancesReducer, InsurancesState } from './insurances/reducers';
import { clinicsReducer, ClinicsState } from './clinics/reducers';
import { hospitalsReducer, HospitalsState } from './hospitals/reducers';
import { languagesReducer, LanguagesState } from './languages/reducers';

export interface FindProviderState {
  providerSuggestions: ProviderSuggestionsState;
  search: SearchState;
  facets: FacetsState;
  insurances: InsurancesState;
  clinics: ClinicsState;
  hospitals: HospitalsState;
  languages: LanguagesState;
}

export default combineReducers({
  providerSuggestions: providerSuggestionsReducer,
  search: searchReducer,
  facets: facetsReducer,
  insurances: insurancesReducer,
  clinics: clinicsReducer,
  hospitals: hospitalsReducer,
  languages: languagesReducer
});
